export default {
  PROPERTY_GROUPS: 'companies/:company_id/property-groups/'
}